/**
 * This function generates baseUrl dynamic depending on the environment used from v4 context
 * @param context v4Context
 * @returns public API URL
 */
export function publicApiUrlHandler(context) {
  if (context.environment === 'integration') {
    context.baseUrl = `https://${context.machineName}-api.scalefast.ninja`;
  } else if (context.environment === 'development') {
    context.baseUrl = `https://dev-v4-${context.machineName}-api.scalefast.pizza`;
  } else {
    // TODO: when more regions will be needed 'eu' param will be variable
    context.baseUrl = 'https://eu-api.scalefast.com';
  }
  return context.baseUrl;
}
